import React from "react";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import PropTypes from "prop-types";
import NoSsr from "@material-ui/core/NoSsr";
import {withStyles} from "@material-ui/core/styles";
import {setStroke} from "../../AC/set-stroke";
import ColorPicker from "../ColorPicker";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import StrokeIcon from "../../../../icons/StrokeIcon";
import WithoutStrokeIcon from "../../../../icons/WithoutStrokeIcon";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import withMobileContext from "../../decorators/withMobileContext";
import {STROKE_CHANGED} from "../../constants/event-types";
import Mediator from "../../services/Mediator";
import Slider from "@material-ui/lab/Slider";
import TextField from "@material-ui/core/TextField";
import trackEvent from "../../../../utils/track-event";

const styles = {
  slider: {
    padding: `22px 0px`,
    width: `160px`,
    margin: `0 0 0 10px`,
    display: `inline-block`
  },
  root: {
    padding: `12px 2px 12px 8px`,
    borderRadius: `3px`
  },
  track: {
    backgroundColor: `#838587`
  },
  thumb: {
    backgroundColor: `#838587`
  },
  textField: {
    width: `70px`,
    height: `44px`,
    margin: `0`
  }
};

class Stroke extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    setStroke: PropTypes.func,
    selected: PropTypes.object,
    isMobile: PropTypes.bool
  };
  state = {
    stroke: this.props.selected.stroke,
    strokeWidth: this.props.selected.strokeWidth
  };
  componentDidMount() {
    Provider.subscribe(STROKE_CHANGED, this.onStrokeChanged);
  }
  componentWillUnmount() {
    Provider.unsubscribe(STROKE_CHANGED, this.onStrokeChanged);
  }
  componentDidUpdate(prevProps) {
    const {selected: prevSelected} = prevProps;
    const {selected} = this.props;
    if (selected && JSON.stringify(selected) !== JSON.stringify(prevSelected)) {
      this.setStateFromObject(selected);
    }
  }
  onStrokeChanged = (_, target) => {
    this.setStateFromObject(target);
  };
  handleStroke = ({hex}, pickerType) => {
    this.setState({
      stroke: hex
    });
    this.props.setStroke({
      stroke: hex,
      strokeWidth: this.state.strokeWidth ? this.state.strokeWidth : 2
    });
    if (pickerType === `palette`) {
      trackEvent({
        category: `Editor`,
        action: `Palette color`,
        label: `Stroke`
      });
    }
  };
  handleStrokeWidth = ({target}, width) => {
    const value = parseInt(target.value, 10) || width || 0;
    this.setState({
      strokeWidth: value
    });
    this.props.setStroke({
      stroke: this.state.stroke,
      strokeWidth: value
    });
  };
  setStateFromObject = (object) => {
    const {stroke, strokeWidth} = object;
    this.setState({
      stroke,
      strokeWidth
    });
  };
  render() {
    const {classes, selected, isMobile} = this.props;
    const {stroke, strokeWidth} = this.state;
    const isEmptyStroke =
      stroke === `transparent` || stroke === null || strokeWidth === 0;
    return (
      !!selected &&
      (Mediator.isImage(selected) ||
        Mediator.isText(selected) ||
        Mediator.isPath(selected)) && (
        <NoSsr>
          <div className="panel-control__item stroke-picker">
            <ColorPicker
              color={stroke ? stroke : `transparent`}
              onChange={this.handleStroke}
              position={isMobile ? `top-center` : `bottom-right`}
              content={
                <React.Fragment>
                  <TextField
                    id="outlined-name"
                    value={strokeWidth}
                    onChange={this.handleStrokeWidth}
                    InputProps={{
                      classes: {
                        root: classes.textField
                      }
                    }}
                    variant="outlined"
                    type="number"
                    min={0}
                    max={100}
                    step={1}
                  />
                  <Slider
                    classes={{
                      root: classes.slider,
                      track: classes.track,
                      thumb: classes.thumb
                    }}
                    value={strokeWidth}
                    min={0}
                    max={100}
                    step={1}
                    aria-labelledby="label"
                    onChange={this.handleStrokeWidth}
                  />
                </React.Fragment>
              }
            >
              <Tooltip title="Обводка">
                <IconButton
                  classes={{root: classes.root}}
                  onClick={this.handleClick}
                >
                  <div
                    className="palette"
                    style={isEmptyStroke ? {color: `#000`} : {color: stroke}}
                  >
                    {isEmptyStroke ? <WithoutStrokeIcon /> : <StrokeIcon />}
                  </div>
                  <ArrowDropDownIcon />
                </IconButton>
              </Tooltip>
            </ColorPicker>
          </div>
        </NoSsr>
      )
    );
  }
}

export default withStyles(styles)(
  connect(null, {setStroke})(withMobileContext(Stroke))
);
